<template>
  <div class="pg-form-group" :style="groupStyle" v-if="item.visible">
    <div class="pg-form-group__header" v-if="item.label" @click="collapse">
      <h3>{{ item.label }}</h3>
      <i class="ivu-icon-ios-arrow-down" :class="{ close: !show }"></i>
    </div>
    <CollapseTransition>
      <div class="pg-form-group__content" :style="contentStyle" v-show="show">
        <slot></slot>
      </div>
    </CollapseTransition>
  </div>
</template>
<script setup>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import { ref, computed } from 'vue'

const props = defineProps({
  item: Object,
  inline: Boolean,
})

const contentStyle = computed(() => {
  const temp = {
    paddingTop: !props.item.label && props.item.children.some((im) => im.label) ? '10px' : 0,
    paddingLeft: !props.inline && props.item.children?.length > 1 ? '20px' : 0,
    paddingRight: props.item.children?.length > 1 ? '20px' : '0px',
    ...props.item.parameter?.contentStyle,
  }
  if (props.item?.parameter?.full) {
    temp.flex = 1
  }
  return temp
})

const groupStyle = computed(() => {
  const defaultStyle = { backgroundColor: props.item?.parameter?.backgroundColor ?? '#ffffff' }
  if (props.item?.parameter?.full) {
    defaultStyle.display = 'flex'
    defaultStyle.height = 'calc(100% - 10px)'
  }
  return Object.assign(defaultStyle, props.item?.style)
})

const show = ref(true)
const collapse = () => {
  show.value = !show.value
}
</script>
<style lang="scss">
@import '../style/form-group.scss';
</style>
